import { combineEpics } from "redux-observable";
import { Observable } from "rxjs";
import { filter, map } from "rxjs/operators";
import { Dependancies } from "../storeTypes";
export const key = "tideDate";

export enum actionTypes {
  SET_TIDEDATE = "met/tideDate/SET_TIDEDATE",
}

type SetTideDateAction = {
  type: actionTypes.SET_TIDEDATE;
  tideDate: string;
  tideDate2?: string;
};

type Actions = SetTideDateAction;

// Default state now includes both tideDate and tideDate2
export type TideDateState = {
  tideDate: string;
  tideDate2?: string;
};

const initialState: TideDateState = {
  tideDate: "",
};

export function Reducer(
  state: TideDateState = initialState,
  action: Actions
): TideDateState {
  switch (action.type) {
    case actionTypes.SET_TIDEDATE:
      return {
        tideDate: action.tideDate,
        tideDate2: action.tideDate2,
      };
    default:
      return state;
  }
}

const setTideDateAction = (
  tideDate: string,
  tideDate2?: string
): SetTideDateAction => ({
  type: actionTypes.SET_TIDEDATE,
  tideDate,
  tideDate2,
});

const inittideDateEpic = (
  action$: Observable<any>,
  _: any,
  deps: Dependancies
) =>
  action$.pipe(
    filter((x) => x.type === "INIT"),
    map(() => setTideDateAction(deps.tideDate, deps.tideDate2))
  );

export const epic = combineEpics(inittideDateEpic);

// Keep selector for tideDate (retrocompatibility) and add tideDate2
export const Selectors = {
  all: (state: any): TideDateState => state[key],
  tideDate: (state: any): string => state[key].tideDate,
  tideDate2: (state: any): string => state[key].tideDate2,
};
